import React from 'react';
import JoditEditor from "jodit-react";

export default class TextEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content: '',
        }
    }

    updateContent = (value) => {
        this.setState({ content: value }, (() => { this.props.onChange(value, this.props.name) }))
    }

    jodit;
    setRef = jodit => this.jodit = jodit;

    config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        language: "es",
        buttons: ["undo", "redo", "|", "cut", "copy", "paste", "|", "font", "fontsize", "|", "bold", "italic", "underline", "|", "indent", "outdent", "|", "left", "center", "right", "justify", "|", "ul"],
        limitChars: 1200,
        direction: "ltr",
        placeholder: "Escriba aquí"
    }

    render() {
        const { placeholder } = this.props;
        const config = {
            ...this.config,
            placeholder: placeholder || this.config.placeholder // Use prop or fallback to default
        };

        return (
            <JoditEditor
                ref={this.setRef}
                value={this.props.value}
                config={config}
                onBlur={this.updateContent}
                onChange={() => { }}
            />
        );
    }
}